import { Loader2 } from 'lucide-react';
import PropTypes from 'prop-types';

const SkeletonLine = ({ width = '100%', height = '16px' }) => (
  <div className="skeleton-line" style={{ width, height }} />
);

SkeletonLine.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

const ScopeAnalysisLoading = () => {
  return (
    <div className="scope-analysis-loading">
      <div className="loading-header">
        <Loader2 className="loading-spinner" />
        <span>Loading scope analysis...</span>
      </div>

      <div className="loading-content">
        {/* Simulate tab navigation skeleton */}
        <div className="tabs-skeleton">
          <div className="tab-skeleton active" />
          <div className="tab-skeleton" />
          <div className="tab-skeleton" />
        </div>

        {/* Simulate table content skeleton */}
        <div className="table-skeleton">
          <div className="table-header-skeleton">
            <SkeletonLine width="200px" />
            <SkeletonLine width="150px" />
            <SkeletonLine width="150px" />
            <SkeletonLine width="150px" />
          </div>

          {[1, 2, 3, 4].map((row) => (
            <div key={row} className="table-row-skeleton">
              <div className="row-content-skeleton">
                <SkeletonLine width="180px" height="20px" />
                <SkeletonLine width="100%" height="14px" />
              </div>
              <SkeletonLine width="80px" height="24px" />
              <SkeletonLine width="80px" height="24px" />
              <SkeletonLine width="80px" height="24px" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScopeAnalysisLoading;
